import {Action, configureStore, ThunkAction} from '@reduxjs/toolkit';
import {useDispatch} from 'react-redux';
import {baseApi} from '../api/rtk-queries/queryApiCreator';
import consultantSettingsReducer from '../features/consultantSettingsSlice';
import identitetListeReducer from '../features/identitetListe/IdentitetListeSlice';
import layoutReducer from '../features/layout/layoutSlice';
import logReducer from '../features/logSlice';
import meSettingsReducer from '../features/meSettingsSlice';


export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    layout: layoutReducer,
    log: logReducer,
    identiteter: identitetListeReducer,
    meSettings: meSettingsReducer,
    consultantSettings: consultantSettingsReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware)
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType,
  RootState,
  unknown,
  Action<string>>;
